var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"link",attrs:{"id":"about"}},[_vm._v("Daniel Fernandes - 2020")])}
var staticRenderFns = []

export { render, staticRenderFns }